import { Component, OnInit, OnDestroy, NgModule } from '@angular/core';
import { APIURL } from '../../../Shared/Constant/API_Urls';
import { UrlsService } from '../../../Shared/Services/urls.service';
import { SharedHttpClientService } from '../../../Shared/Services/shared-http-client.service';
import { UserService } from '../../../Shared/Services/user.service';
import { EmitterService } from '../../../Shared/Services/emitter.service';
import { HttpErrorResponse } from '@angular/common/http';
import { TransactionSummary } from './transaction-exception-summary.model';
import { map, Subscription } from 'rxjs';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { ProgressBarModule } from 'primeng/progressbar';
import { DatePipe, NgClass } from '@angular/common';

@Component({
    selector: 'app-transaction-exception-summary',
    imports: [DatePipe, MatTooltipModule, MatProgressBarModule, ProgressBarModule, NgClass],
    templateUrl: './transaction-exception-summary.component.html',
    styleUrls: ['./transaction-exception-summary.component.scss']
})
export class SummaryComponent implements OnInit, OnDestroy {

  mpidlist!: number;
  first: boolean = true;
  equities!: number;
  IMIDlist!: number;
  SOD!: number;
  nasdaqlisted!: number;
  options!: number;
  ClientProcessPercent: number = 100;
  CatProcessPercent: number = 100;
  ClientProcessTitle: string = "Client"
  CatProcessTitle: string = "CAT"
  loading!: boolean;
  data:any;
  count: any;
  loadtime: any = '00:00:00'
  subtime: any = '00:00:00'
  runtime: any = '00:00:00'

  subscription!: Subscription;
  constructor(
    private UrlService: UrlsService,
    private UserService: UserService,
    private SharedHttpClientService: SharedHttpClientService,
    private EmitterService: EmitterService,
    private date: DatePipe) {
  }

  getData() {
    this.SharedHttpClientService.post(this.UrlService.setAPIURl(APIURL.MD_Transactio_Exception_Summary), {
      "mpid": this.UserService.getActiveMPID(),
      "days": 30,
      "userid": this.UserService.getUid()
    })
      .pipe(map((response: Response) => {
        return response;
      })).subscribe(dataset => {
        let data: any = dataset;
        this.data = data;
      },
        (err: HttpErrorResponse) => {
          this.data = new TransactionSummary();
        });
  }

  ngOnInit() {
    this.getData();
    this.subscription = this.EmitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }
    });
  }

 
  Processbar() {
    if (this.ClientProcessPercent != 100) {
      if (this.ClientProcessPercent < 50)
        this.ClientProcessTitle = "Client Process"
      else this.ClientProcessTitle = "Client Process"
    } else {
      this.ClientProcessTitle = "Client Process Done"
    }

    if (this.CatProcessPercent != 100) {
      if (this.CatProcessPercent < 50)
        this.CatProcessTitle = "CAT Processing .."
      else this.CatProcessTitle = "CAT Processing .."
    } else {
      this.CatProcessTitle = "CAT Process Done"
    }
  }

  ngAfterViewInit() {
    //this.Processbar();
    /* refresh file process time after 5 min */
    /* 
     if (this.first===true) {
     Observable.interval(1000 * 2 * 1).subscribe(x => {
       if (this.first===true) {
         this.MarketDataFilesDot()
       }
    
     });
   }*/
  }
  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }
}
